import { PlayerError } from '@dtvgo/player-common-utils';

function isLicenseError(error) {
  return error.code === PlayerError.Code.LICENSE_REQUEST_FAILED;
}
function removePeriodsWithoutAudio(dashManifestXML) {
  for (const period of dashManifestXML.querySelectorAll("Period")) {
    if (period.querySelectorAll('AdaptationSet[mimeType="audio/mp4"],AdaptationSet[contentType="audio"]').length === 0) {
      period.remove();
    }
  }
  return dashManifestXML;
}

export { isLicenseError, removePeriodsWithoutAudio };
//# sourceMappingURL=utils.js.map
